import axios, { AxiosProgressEvent } from "axios";
import { useContext } from "react";
import { APIContext } from "../contexts/apiContext";

export interface IUploadArtworkResponse {
  id: string;
  contentType: string;
  src: string;
}

const useWebsiteApi = () => {
  const { baseUrl } = useContext(APIContext);
  const fetcher = (path) => fetch(baseUrl + path).then((res) => res.json());

  return {
    fetcher,
    quote: async (params: URLSearchParams) => {
      return await fetcher(`/v4/calc?${params.toString()}`);
    },
    getCart: async (cartId: string) => {
      const resp = await fetch(`${baseUrl}/v4/cart/${cartId}/shopify`);

      return await resp.json();
    },
    removeFromCart: async (cartId: string, cartItemId: string) => {
      const resp = await fetch(
        `${baseUrl}/v4/cart/${cartId}/items/${cartItemId}`,
        { method: "DELETE" }
      );

      return await resp.json();
    },
    retrieveOrders: async (
      email: string,
      orderNumber: string,
      storeHash: string
    ) => {
      const params = new URLSearchParams();
      params.set("email", email);
      params.set("orderNumber", orderNumber);
      params.set("storeHash", storeHash);

      return await fetcher(`/v4/reorder?${params.toString()}`);
    },
    uploadArtwork: (
      f: File,
      onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
    ) => {
      const form = new FormData();
      form.set("file", f);

      return axios
        .postForm<IUploadArtworkResponse>(baseUrl + "/v1/media", form, {
          onUploadProgress,
        })
        .then((resp) => {
          return { ...resp.data, src: baseUrl + resp.data.src };
        });
    },
    createProject: async (
      templateCode: string
    ): Promise<{ success: boolean; data: { project_id: string } }> => {
      const params = new URLSearchParams();
      params.set("code", templateCode);

      return await fetch(
        `https://graphic.stickerit.co/api/create?${params.toString()}`
      ).then((res) => res.json());
    },
  };
};

export default useWebsiteApi;
